/**
 * Storlyn 品牌 - Book 页面配置
 */
import { commonTexts } from './common'
import type { BookPageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

export const theme = {
  quoteColor: 'rgba(238, 59, 164, 0.24)',
  tocLockColor: brandTheme.primaryColor,
} as const

export const bookConfig: BookPageConfig = {
  theme,
  texts: commonTexts,
}
